import { Navigate, Route, Routes } from 'react-router-dom';

import { MenuInfo } from 'data';
import { Error404 } from 'pages';
import { MonitoringSettingLayout, MonitoringSettingTabsLayout } from 'layout/monitoring';

export default function MonitoringSettingTabsRoutes(props) {
    const { menuId } = props;
    const tabs = MenuInfo.ROOT.find(menuId);
    // console.log(tabs)
    if (tabs?.children && tabs?.children.length > 0) {
        return (
            <Routes>
                <Route path="/*" element={ <MonitoringSettingTabsLayout menuId={menuId}/> }>
                    {/* {tabs?.children && tabs?.children.length > 0 && <> */}
                    <Route path="/*" element={ <Navigate to={tabs.children[0].path}/> }/>
                    {
                        tabs.children.map(child => {
                            return (
                                <Route key={child.id} path={child.path + (child.isRoutes ? '/*' : '')} element={ child.element }/>
                            );
                        }) 
                    }
                    {/* </>} */}
                    <Route path="*" element={ <Error404/> }/>
                </Route>
            </Routes>
        );
    } else {
        return (
            <Routes>
                <Route path="/*" element={ <MonitoringSettingLayout menuId={menuId}/> }>
                    <Route path="/*" element={ <Navigate to={tabs.path}/> }/>
                    {
                        tabs.children.map(child => {
                            return (
                                <Route key={child.id} path={child.path + (child.isRoutes ? '/*' : '')} element={ child.element }/>
                            );
                        }) 
                    }
                    <Route path="*" element={ <Error404/> }/>
                </Route>
            </Routes>
        );
    }
}